module.exports = __webpack_public_path__ + "img/auth-bg-2.6db1cc3d.jpg";